import type { MockNycClinic } from './types';

export const LMI_MIN_RADIUS_MILES = 1;
export const LMI_MAX_RADIUS_MILES = 20;

export const MOCK_NYC_CLINICS: readonly MockNycClinic[] = [
  {
    name: 'Smile Central Dental — Midtown',
    fullAddress: '350 5th Ave, New York, NY 10118',
  },
  {
    name: 'Park Avenue Dental Group',
    fullAddress: '230 Park Ave, New York, NY 10169',
  },
  {
    name: 'West Village Family Dentistry',
    fullAddress: '154 Bleecker St, New York, NY 10012',
  },
  {
    name: 'Upper East Smiles',
    fullAddress: '1311 3rd Ave, New York, NY 10021',
  },
  {
    name: 'Brooklyn Heights Dental',
    fullAddress: '145 Montague St, Brooklyn, NY 11201',
  },
  {
    name: 'Financial District Oral Care',
    fullAddress: '40 Wall St, New York, NY 10005',
  },
];

export const LMI_MOCK_SPENDS = [
  '$2,100/mo',
  '$1,840/mo',
  '$2,760/mo',
  '$1,590/mo',
  '$2,320/mo',
] as const;

export const LMI_MOCK_KEYWORDS = [
  'Emergency Tooth Extraction',
  'Same-Day Dental Pain Relief',
  '24/7 Dental Emergency Clinic',
] as const;

export const LMI_MOCK_CPCS = [
  'CPC: ~$1.20 (Low)',
  'CPC: ~$1.10 (Low)',
  'CPC: ~$1.30 (Low)',
] as const;

export const LMI_MOCK_GOOGLE_AD_KEYWORDS = [
  { label: 'Invisalign', tone: 'success' as const },
  { label: 'Cosmetic', tone: 'info' as const },
  { label: 'Emergency Extraction', tone: 'warning' as const },
  { label: 'Teeth Whitening', tone: 'gold' as const },
];

export function getMockNycClinicForLocationId(locationId: number | null): MockNycClinic {
  const index =
    locationId === null ? 0 : Math.abs(locationId) % MOCK_NYC_CLINICS.length;
  return MOCK_NYC_CLINICS[index] ?? MOCK_NYC_CLINICS[0]!;
}
